import React from 'react';
import {AuthContext} from "../../authContext";
import moment from 'moment';

import iconCloudUpload from "../../assets/images/icons/cloud_upload.svg";
import iconCloudDownload from "../../assets/images/icons/cloud_download.svg";
import iconNavigateUp from "../../assets/images/icons/navigate_up.svg";
import iconNavigateDown from "../../assets/images/icons/navigate_down.svg";
import iconDelete from "../../assets/images/icons/delete3.svg";

import Alert from "../shared/Alert";
import Button from '../shared/Button';
import Flex from "../shared/Flex";
import getFileSizeDescription from '../shared/utilities/getFileSizeDescription';
import getResourceIconFromType from '../shared/utilities/getResourceIconFromType';
import Loading from '../shared/Loading';
import openResource from "../shared/utilities/openResource";
import saveResource from "../shared/utilities/saveResource";
import TableRowContainer from "../shared/TableRowContainer";
import TableRowDetailsContainer from "../shared/TableRowDetailsContainer";

class ProjectResourcesTable extends React.Component {
  static contextType = AuthContext;
  state = {
    saveResourceID: null
  };
  open = async id => {
    await openResource(id, this.context.token);
  };
  save = async id => {
    await saveResource(id, this.context.token);
  };
  showSaveResourceAlert = async id => {
      await this.setState({saveResourceID: id});
  };
  render() {
    return (
      <div style={{borderTop: "1px solid #cdcdcd", marginTop: "10px", width:"100%"}}>
        {this.props.isLoading && <Loading />}
        {
          this.props.data.map(resource => {
            return (
              <TableRowContainer
                key={resource.id}
                onClick={() => { this.props.toggleResourceVisibility(resource.id)}}
              >
                <TableRowDetailsContainer isVisible={resource.isVisible}>
                  <div style={{minWidth:"35px"}}>
                    {getResourceIconFromType(resource.type)}
                  </div>
                  <div>
                    <div>{resource.name}</div>
                    {
                      resource.isVisible
                      &&
                      <div style={{marginTop: "4px"}}>
                        <small>
                          Size: {getFileSizeDescription(resource.size)} &bull; Last modified: {moment(resource.modifiedAt).format('DD MMM YYYY')}
                        </small>
                        {
                          resource.id === this.state.saveResourceID
                          &&
                          <Alert style={{marginTop:"5px"}}>
                            <p>Save model? This will overwrite your saved model '{resource.name}' with the model currently open in CityCAD.</p>
                            <Flex>
                              <Button small onClick={e => { e.stopPropagation(); this.showSaveResourceAlert(null) }}>Cancel</Button>
                              <Button small danger onClick={e => { e.stopPropagation(); this.save(resource.id) }}>Proceed</Button>
                            </Flex>
                          </Alert>
                        }
                        <div style={{display:"flex", alignContent:"center", marginTop: "7px"}}>
                          <Button
                            style={{display: "flex", justifyContent: "space-around", alignItems:"center", minWidth:"70px", maxHeight:"24px"}}
                            small
                            onClick={e => { e.stopPropagation(); this.props.showDeleteResourceAlert(resource); }}
                          >
                            <img src={iconDelete} alt={`Delete`} style={{width: "14px"}} />Delete
                          </Button>
                          {
                            (resource.type === "application/urb" && this.props.projectData.isCanEdit === "1")
                            &&
                            <Button
                              style={{display: "flex", justifyContent: "space-around", alignItems: "center", minWidth: "70px", maxHeight: "24px", marginLeft: "7px"}}
                              small
                              onClick={e => { e.stopPropagation(); this.showSaveResourceAlert(resource.id); }}
                            >
                              <img src={iconCloudUpload} alt={`Save`} style={{width: "18px"}}/> Save
                            </Button>
                          }
                          <Button
                            style={{display: "flex", justifyContent: "space-around", alignItems:"center", minWidth:"70px", maxHeight:"24px", marginLeft:"7px"}}
                            small
                            onClick={e => { e.stopPropagation(); this.open(resource.id); }}
                          >
                            <img src={iconCloudDownload} alt={`Save`} style={{width:"18px",marginRight:"5px"}} /> {this.props.projectData.isCanEdit === "1" ? ` Open` : ` Open a copy`}
                          </Button>
                        </div>
                      </div>
                    }
                  </div>
                </TableRowDetailsContainer>
                <div style={{width:"32px"}}>
                  {
                    resource.isVisible
                      ?
                      <img src={iconNavigateUp} alt={`Up`} style={{width: "10px", height: "13px"}} />
                      :
                      <img src={iconNavigateDown} alt={`Down`} style={{width: "10px", height: "13px"}} />
                  }
                </div>
              </TableRowContainer>
            )
          })
        }
      </div>
    )
  }
};

export default ProjectResourcesTable;
